import { useQuery } from "react-query";
import { getPurchaseInvoiceConstants } from "./service";

export const useGetPurchaseInvoiceConstants = () => {
  return useQuery({
    queryKey: ["purchse-invoice-constants"],
    queryFn: () => getPurchaseInvoiceConstants(),
  });
};
